import React, { useEffect, useState } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import { ADMISION } from './Styles/StylesAdmision';

import logo from "../../assets/img/logo_menu_black.png";
import { formatNumber, formatReconver } from "../../funciones/GeneralFunctions";

const ReciboDePagoList = (props) => {
    const styles = StyleSheet.create(ADMISION[0]);

    let detalle = (valor, metodo, total) => {
        let contenido = []
        
        for(let i in valor){
            contenido.push(
                <View style={[styles.row]}>
                    <Text style={[styles.colTablaCuenta4, styles.font7, styles.bordeCol9, styles.borderTop, styles.justify]}>
                        {valor[i].fecha} - {valor[i].banco} - <Text style={{color: "#c60000"}}>{valor[i].item}</Text> {formatNumber(valor[i].haber)} Bs. <Text>------------------------------------------------------------------</Text>
                    </Text>
                </View>
            )
        }

        return (
            <View style={[styles.row]}>
                {contenido}
                <View style={[styles.colTablaCuenta4]}>
                    <Text style={{backgroundColor: "#777", color:"#FFF", textAlign: "right"}}>{metodo} {formatNumber(total)} Bs.</Text>
                    {/* <Text style={{backgroundColor: "#777", color:"#FFF", textAlign: "right"}}>{metodo} {formatReconver(total)} Bs.</Text> */}
                </View>
            </View>
        )
    }

    let recibos = () => {
        if (props.datos.length === 0) return (
            <View style={[styles.row]}>
                <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>Sin Resultados</Text>
            </View>
        )
        return (
            props.datos.map(option => (
                <View key={option.Id} style={[styles.row]}>
                    <Text style={[styles.colTablaCuenta1, styles.font7, styles.bordeCol11, styles.borderTop, styles.center,]}>{option.Id}</Text>
                    <Text style={[styles.colTablaCuenta6, styles.font7, styles.bordeCol9, styles.borderTop, styles.justify]}>
                        {option.Ci} <Text style={{color: "#c60000"}}>{option.Est}</Text>
                    </Text>
                    <Text style={[styles.colTablaCuenta5, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>
                        {detalle(option.Detalle, option.Metodo, option.Total)}
                    </Text>
                    <Text style={[styles.colTablaCuenta4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>
                        {option.Estatus}
                    </Text>
                    <Text style={[styles.colTablaCuenta4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center]}>
                        {option.Factura}
                    </Text>
                </View>
            ))
        )
    }

    let contenido = () => (
        <React.Fragment>
            <View style={styles.row}>
                <Image
                    style={[styles.colContent40, styles.logo]}
                    src={logo}
                />
                <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                    <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                    <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                </View>
            </View>
            <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                RECIBOS DE PAGO
            </Text>
            <Text style={[styles.textPeq, {textAlign: "right", marginBottom: 0}]}>Cantidad de recibos mostrados: {props.cantidad}</Text>
            <Text style={[styles.textPeq, {textAlign: "right", marginTop: 0}]}>Parte: {props.pagina} / {props.paginas}</Text>
            <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF",}]}>
                <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                    <View style={[styles.row]}>
                        <Text style={[styles.colTablaCuenta1, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>N°</Text>
                        <Text style={[styles.colTablaCuenta6, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Estudiante</Text>
                        <Text style={[styles.colTablaCuenta5, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Detalles</Text>
                        <Text style={[styles.colTablaCuenta4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Estatus</Text>
                        <Text style={[styles.colTablaCuenta4, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Factura</Text>
                    </View>
                    {recibos()}
                </View>
            </View>
        </React.Fragment>
    )

    return (
        <PDFViewer style={styles.section}>
            <Document title="Recibos de Pago">
                <Page size="letter" style={styles.body}>
                    <View>
                        {contenido()}
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    );
}

export default ReciboDePagoList;


// WEBPACK FOOTER //
// ./src/components/Reportes/ReciboDePagoList.jsx